import { useSyncExternalStore } from 'react'

// Session values are written imperatively during the auth flow and don't change
// under a mounted step, so there's no live source to subscribe to.
const noopSubscribe = () => () => {}

/**
 * Read of a `sessionStorage`-backed value via `useSyncExternalStore`.
 *
 * (In this CSR-only app the client snapshot is used immediately; the server
 * snapshot is retained for parity with the original.)
 */
export function useSessionValue(read: () => string | null): string | null {
  return useSyncExternalStore(noopSubscribe, read, () => null)
}
